import React from 'react';
import Logo from 'common/components/TouchpointEditor/components/TouchpointNodes/Logo';
import { CONTENT_TYPE_LIGHT_LOGO } from 'common/components/TouchpointEditor/components/TouchpointNodes/Logo/constants';

export default function ContentLogo(props) {
    return <Logo {...props} />;
}

ContentLogo.splash = {
    ...Logo.splash,
    defaultProps: {
        ...Logo.splash.defaultProps,
        meta: {
            ...Logo.splash.defaultProps.meta,
            logoType: CONTENT_TYPE_LIGHT_LOGO,
        },
    },
};
